import { applyActionParams } from "@/action/actions";
import { navigationActions } from "@/action/navigationActions";
import { toggleActions } from "@/action/toggleActions";
import { relativeClientCoord } from "@/math/coordinate-utils";
import type { RelativeCoordinate } from "@/model/coordinates";
import { useSessionStore } from "@/store/session";

import { BaseBoard } from "./BaseBoard";
import type { PlanningBoardLocation } from "./location/PlanningBoardLocation";

export type Planning = "program" | "solution";

export abstract class BasePlanningBoard<T extends Planning> extends BaseBoard<T> {
  nonTeamGroup(name: string) {
    return { id: "", name, iterations: useSessionStore().iterations };
  }

  override get showRiskyLinks() {
    return true;
  }

  abstract override location(
    pos: RelativeCoordinate | number | string,
    top?: number,
  ): PlanningBoardLocation;

  get contextActions() {
    return {
      board: { draw: this.drawAction(), kanban: navigationActions.showKanban },
      selection: { organize: true, link: true },
    };
  }

  override positionalActions(c: RelativeCoordinate) {
    const loc = this.location(c);
    return {
      region: { name: loc.names().join(" "), actions: { overview: this.overviewAction(loc) } },
    };
  }

  overview(e: MouseEvent) {
    this.overviewAction(this.location(relativeClientCoord(e)))?.("mouse");
  }

  overviewAction(
    loc: PlanningBoardLocation,
    setReturnFocus?: string, // Selector of element to be focused when overview is closed
  ) {
    return applyActionParams(toggleActions.showOverview, {
      boardId: this.board.id,
      location: loc.id(),
      load: loc.groupIteration?.load,
      velocity: loc.groupIteration?.velocity,
      setReturnFocus,
    });
  }
}
